export type AreaStorage = {
  count: number;
  bytes: number;
  deletedCount: number;
  deletedBytes: number;
  recentCount: number;
  recentBytes: number;
  oldest?: string;
};

export type Storage = {
  documents: AreaStorage;
  events: AreaStorage;
  eventsCleared: AreaStorage;
  devices: AreaStorage;
};

export type BuildingStorage = {
  buildingId: string;
  name: string;
  storage: Storage;
  totalBytes: number;
};

export type OrganizationStorage = {
  organizationId: string;
  name: string;
  type: string;
  storage: Storage;
  totalBytes: number;
  buildings: BuildingStorage[];
};

export type StorageSnapshot = {
  id: string;
  createdAt: string;
  durationMs: number;
  recentDays: number;
  totals: Storage;
  totalBytes: number;
  organizations: OrganizationStorage[];
};

export type StorageArea = keyof Storage;

export const ORGANIZATION_TYPE_DEACTIVATED = 'DEACTIVATED';

// Display order, labels, and chart colors for each storage area
export const STORAGE_AREAS: {
  key: StorageArea;
  label: string;
  color: string;
}[] = [
  { key: 'eventsCleared', label: 'Cleared Events', color: '#2a78d6' },
  { key: 'events', label: 'Open Events', color: '#eb6834' },
  { key: 'devices', label: 'Devices', color: '#1baf7a' },
  { key: 'documents', label: 'Documents', color: '#eda100' },
];
